import { useTranslation } from "react-i18next";

import { Select } from "@/components/ui";
import type { Agent } from "@/leads/queries";
import type { Blocker } from "./model";

/**
 * *Asignar a* — step two of the window, and it stays in view from there on.
 *
 * Every call ends with a seller, so the choice of one is not a field of any
 * single result: it applies to whichever button is pressed, forty rows further
 * down. It sits under the caller's details, where it is asked, and pins to the
 * top once the lists scroll past it. It carries the two things that can stand
 * between reception and those buttons — what is still missing, and what the
 * server refused.
 */
export function AssignBar({
  agents,
  value,
  onChange,
  blocker,
  error,
}: {
  agents: readonly Agent[];
  /** The chosen agent's id as text, or "" while nobody is chosen. */
  value: string;
  onChange: (value: string) => void;
  /** What stops a call being handed to a company nobody holds, if anything. */
  blocker: Blocker | null;
  /** The last refusal, in the server's words. */
  error: string | null;
}) {
  const { t } = useTranslation();
  return (
    <div className="sticky top-0 z-10 mb-6 border-2 border-rule bg-ground px-4 py-3">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <label htmlFor="reception-agent" className="font-display font-extrabold">
          {t("reception.assignTo")}
        </label>
        <Select
          id="reception-agent"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className="w-auto min-w-56"
        >
          <option value="">{t("reception.pickAgent")}</option>
          {agents.map((agent) => (
            <option key={agent.id} value={String(agent.id)}>
              {agent.name}
            </option>
          ))}
        </Select>
        <p className="text-xs text-mute-600">
          {blocker ? t(`reception.blocked.${blocker}`) : t("reception.assignHint")}
        </p>
      </div>
      {error ? (
        <p role="alert" className="mt-2 text-sm text-brand-700">
          {error}
        </p>
      ) : null}
    </div>
  );
}
